'use client';

import '@/global.css';

import * as Sentry from '@sentry/nextjs';
import classnames from 'classnames';
import { useEffect } from 'react';

import Body from '@/components/body';
import ErrorTitle from '@/components/error-title';
import ErrorView from '@/views/error-view';
import Html from '@/components/html';
import locales from '@cache/locales.json';

const className = classnames(
  'flex',
  'flex-1',
  'justify-center',
  'items-center',
  'min-h-full',
  'sm:container',
  'mx-auto',
  'px-3'
);

interface Props {
  error: Error & { digest?: string };
}

const GlobalError = ({ error }: Props) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <Html locale={locales.defaultLocale}>
      <head>
        <link rel="stylesheet" href="/theme.css" />
      </head>
      <Body>
        <main className={className}>
          <ErrorView name="personly">
            <ErrorTitle>An Error Has Occurred</ErrorTitle>
          </ErrorView>
        </main>
      </Body>
    </Html>
  );
};

export default GlobalError;
